import FontFaceObserver from 'fontfaceobserver';
import Service from '@ember/service';
export default class FontLoading extends Service {
  /**
   * Starts observing the loading of the specified font. Immediately returns a
   * new Promise that resolves when the font is available and rejected when the
   * font is not available.
   *
   * @param fontFamilyName Name of the font family to observe.
   * @param variant Description of the font variant to observe. If a property
   *   is not present it will default to normal.
   * @param testString If your font doesn't contain latin characters you can
   *   pass a custom test string.
   * @param timeout The default timeout for giving up on font loading is 3
   *   seconds. You can increase or decrease this by passing a number of
   *   milliseconds.
   */
  load(fontFamilyName, variant, testString, timeout) {
    const observer = new FontFaceObserver(fontFamilyName, variant);
    return observer.load(testString, timeout);
  }
}